<div class="container-fluid p-0" *ngIf="!showPasswordRules" xmlns:svg="">
    <div class="row p-0">
        <div class="centered-box col-12" [ngClass]="boxSize">
            <!-- BODY -->
            <div class="container-fluid p-0">
                <div class="row">
                    <div class="col-8">
                        <h1 jhiTranslate="{{title}}" [translateValues]="translateParams"></h1>
                    </div>
                </div>
                <div class="global-margin" [hidden]="successMsg || errorMsg">
                    <p *ngIf="subTitle" [ngClass]="yellowSubTitle ? 'yellow-text' : ''" class="welcome-message"
                        jhiTranslate="{{subTitle}}"></p>
                    <p *ngIf="requiredFields" class="text-12-centered" jhiTranslate="spans.common.requiredFields"></p>

                    <jhi-list-content-loader *ngIf="contentLoading"></jhi-list-content-loader>

                    <div *ngIf="!contentLoading">
                        <ng-content></ng-content>
                    </div>
                </div>
                <div class="global-margin" *ngIf="successMsg">
                    <div class="row p-0 mb-3" *ngIf="successMsg === 'Incorrect old password.' || successMsg === 'Vecchia password errata.' || successMsg === 'Incorrect confirmation password.' || successMsg === 'Password di conferma non valida.'">
                        <div class="col-sm-12 text-center">
                            <a placement="right" class="blue-anchor" jhiTranslate="spans.changePassword.passwordRules"
                               (click)="showPasswordRules = true">
                            </a>
                        </div>
                    </div>
                    <p class="success-message">{{successMsg}}</p>
                    <div class="row text-center d-flex">
                        <div class="col-12">
                            <button class="btn secondary-btn ladda-button fa max-w-150" data-style="expand-right"
                                (click)="success()">
                                <span class="ladda-label" jhiTranslate="{{successButtonLabel}}">Ok</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="global-margin" *ngIf="errorMsg">
                    <p class="error-message">{{errorMsg}}</p>
                    <div class="row p-0 mb-3" *ngIf="errorMsg === 'Incorrect old password.' || errorMsg === 'Vecchia password errata.' || errorMsg === 'Incorrect confirmation password.' || errorMsg === 'Password di conferma non valida.' || errorMsg === 'Invalid password' || errorMsg === 'Wrong old password' || errorMsg === 'Password non valida' || errorMsg === 'Vecchia password non valida'">
                        <div class="col-sm-12 text-center">
                            <a placement="right" class="blue-anchor" jhiTranslate="spans.changePassword.passwordRules"
                               (click)="showPasswordRules = true">
                            </a>
                        </div>
                    </div>
                    <div class="row text-center d-flex">
                        <div class="col-12">
                            <button class="btn secondary-btn ladda-button fa max-w-120" data-style="expand-right"
                                (click)="failure()">
                                <span class="ladda-label" jhiTranslate="{{failureButtonLabel}}">Ok</span>
                            </button>
                        </div>
                    </div>
                </div>


                <!-- FOOTER -->
                <footer>
                    <div class="row">
                        <div class="col-12">
                            <span *ngIf="organization" class="font-weight-bold">{{ organization }}</span>
                            <br>
                            <span jhiTranslate="{{footerText ? footerText : 'spans.common.disclaimer'}}"></span><br>
                            <span>{{ version }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 logout-end-line" *ngIf="!errorMsg && !successMsg && isUserLogged">
                            <a href="javascript:void(0)" (click)="redirect()">Logout</a>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</div>

<jhi-custom-box [boxSize]="'box-580'" *ngIf="showPasswordRules"
                [title]="'spans.changePassword.passwordRules'">
    <div class="p-0">
        <span jhiTranslate="spans.changePassword.rules.must"> must </span>
        <ul>
            <li jhiTranslate="spans.changePassword.rules.oneNumber"> one numeric </li>
            <li jhiTranslate="spans.changePassword.rules.oneUpper"> one uppercase </li>
            <li jhiTranslate="spans.changePassword.rules.oneSpecial"> one special char </li>
            <li jhiTranslate="spans.changePassword.rules.startAlphabet"> start with alphabet </li>
            <li jhiTranslate="spans.changePassword.rules.different"> different from user - first name - last name </li>
            <li jhiTranslate="spans.changePassword.rules.notAllowedChars"> not allowed chars</li>
            <li jhiTranslate="spans.changePassword.rules.differentLast10"> different from last 10</li>
        </ul>
    </div>
    <button class="btn confirm-btn ladda-button max-w-120" data-style="expand-right"
            (click)="showPasswordRules = !showPasswordRules">
        <span class="ladda-label" jhiTranslate="buttons.back" ></span>
    </button>
</jhi-custom-box>
